var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { createApiCall } from '../../helpers/createAPICall';
export function useAPICallAsync(_a) {
    var _this = this;
    var api = _a.api, _b = _a.notifyLoadingState, notifyLoadingState = _b === void 0 ? true : _b, _c = _a.autoAbortKey, autoAbortKey = _c === void 0 ? '' : _c, _d = _a.baseRoute, baseRoute = _d === void 0 ? '' : _d, checkSelectedGrant = _a.checkSelectedGrant;
    var _e = __read(React.useState({ data: [], loading: false, error: '' }), 2), result = _e[0], setResult = _e[1];
    var t = useTranslation().t;
    var autoAbortsKeys = useRef({});
    var call = useCallback(function (formParams, id, includeTenant, queryParams) {
        if (includeTenant === void 0) { includeTenant = true; }
        return __awaiter(_this, void 0, void 0, function () {
            var abortController, d, result_1, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (autoAbortKey && autoAbortsKeys.current[autoAbortKey]) {
                            autoAbortsKeys.current[autoAbortKey].abort();
                        }
                        abortController = new AbortController();
                        if (autoAbortKey) {
                            autoAbortsKeys.current[autoAbortKey] = abortController;
                        }
                        if (notifyLoadingState) {
                            setResult(function (oldResult) { return (__assign(__assign({}, oldResult), { loading: true })); });
                        }
                        if (!api.endpoint) {
                            setResult({ data: [], loading: false, error: '' });
                            return [2 /*return*/, { data: [], loading: false, error: '' }];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, createApiCall({
                                method: api.method,
                                url: "".concat(baseRoute ? "".concat(baseRoute) : '').concat(api.endpoint.startsWith('/') ? '' : '/').concat(api.endpoint).concat(id ? "/".concat(id) : '').concat(queryParams ? "?".concat(queryParams) : ''),
                                data: formParams,
                                auth: true,
                                checkSelectedGrant: checkSelectedGrant,
                                includeTenant: includeTenant,
                                abortController: abortController,
                            })];
                    case 2:
                        d = _a.sent();
                        result_1 = d.status >= 300 ? { data: d.body, loading: false, error: d.body } : { data: d.body, loading: false, error: '' };
                        if (!d.aborted) {
                            setResult(result_1);
                        }
                        return [2 /*return*/, result_1];
                    case 3:
                        e_1 = _a.sent();
                        setResult({ data: [], loading: false, error: e_1.message });
                        return [2 /*return*/, {
                                data: [],
                                loading: false,
                                error: e_1.message,
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, [api.endpoint, api.method, autoAbortKey, notifyLoadingState]);
    return { result: result, call: call };
}
//# sourceMappingURL=useAPICallAsync.js.map